var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category__tags"},_vm._l((_vm.getCategoriesList),function(category){return _c('button',{key:category.id,staticClass:"category__tag",class:{ active: category.category === _vm.activeTag },on:{"click":function($event){return _vm.changeActiveTag(category.category)}}},[_vm._v(" "+_vm._s(category.subtitle)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }